var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillsPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 6.00391C5.51839 6.00391 3 8.5223 3 11.6289V13.4995H32.9933L32.9941 11.6289C32.9941 8.5223 30.4758 6.00391 27.3691 6.00391H8.625Z",
    fill: "#171717",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 24.3691V15.75H32.9922L32.9883 24.3691C32.9879 27.4755 30.4697 29.9941 27.3633 29.9941H8.625C5.51839 29.9941 3 27.4758 3 24.3691ZM10.125 18.75C9.50368 18.75 9 19.2537 9 19.875C9 20.4963 9.50368 21 10.125 21H14.625C15.2463 21 15.75 20.4963 15.75 19.875C15.75 19.2537 15.2463 18.75 14.625 18.75H10.125Z",
    fill: "#171717",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillsPayment);
export default __webpack_public_path__ + "static/media/bills-payment.142c127b20c48d097a622e06c34ffbf8.svg";
export { ForwardRef as ReactComponent };